import { IonCard, IonIcon } from '@ionic/react'
import { $Enums } from '@vae/server/dist/client'
import {
	SynerallName,
	SynerallProduct,
} from '@vae/server/src/modules/ExternalAPIs/Synerall/synerallTypes'
import { calendarClear, logoEuro, pricetag } from 'ionicons/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../../components/actions/Button'
import useUser from '../../../contexts/hooks/useUser'

interface ProductShowcaseCardProps {
	product: SynerallProduct
	savings: number
	maxKwh?: number
	isSpot: boolean
	onClick?: () => void
	showImage?: boolean
}

const ProductShowcaseCard: React.FC<ProductShowcaseCardProps> = ({
	product,
	savings,
	maxKwh,
	isSpot,
	onClick,
	showImage = true,
}) => {
	const { user } = useUser()

	const { t } = useTranslation('modals_getOurContract')

	return (
		<IonCard className='contract-container text-brand-secondary-100-light dark:text-brand-primary-200-dark'>
			{showImage && <img src='/assets/2024_logos/icon.png' className='icon' />}
			<div className='bg dark:bg-[linear-gradient(75deg,_#3cb49f_0%,_#cae3cc_100%)] bg-[linear-gradient(75deg,_#d6e4ff_0%,_#c9f7d3_100%)]' />
			<span className='contract-name text-brand-secondary-100-light'>
				{
					product.Titles.find((e: any) =>
						user?.language ? e.Lang.toLowerCase() === user?.language : 'fi'
					)?.Value
				}
			</span>

			<div className='contract-prices'>
				{savings > 0 && (
					<div className='price'>
						<span className='child title'>
							<IonIcon icon={pricetag} /> {t('savings')}
						</span>
						<span className='child bolded'>{savings.toFixed(2).replace('.', ',')}€</span>
					</div>
				)}
				{product?.Prices?.map((price, index: number) => {
					const language = user?.language ?? $Enums.Language.fi
					const productPriceUnit =
						price.PriceUnits.find(e => e.Lang.toLowerCase() === language)?.Value?.replace(
							' ',
							''
						) ?? ''

					const isMonthly = price.PriceType === 'Monthly'

					const componentNames =
						price.ComponentNames ?? ([{ Lang: 'fi', Value: '' }] satisfies SynerallName[])
					const name = componentNames.find((x: SynerallName) => x.Lang.toLowerCase() === language)

					return (
						<div key={index} className='price'>
							<span className='child title'>
								{isMonthly ? <IonIcon icon={calendarClear} /> : <IonIcon icon={logoEuro} />}
								{name?.Value ?? ''}
							</span>
							<span className='child'>
								{price.Price.toFixed(2).toString().replace('.', ',')}{' '}
								{productPriceUnit.replace(' ', '')}
							</span>
						</div>
					)
				})}
				<div className='price'>
					<span className='child title'>
						<IonIcon icon={pricetag} /> {t('contractType')}
					</span>
					<span className='child'>{isSpot ? t('spot') : t('fixed')}</span>
				</div>
			</div>

			{onClick && (
				<Button
					className='rounded-full !bg-[linear-gradient(90deg,_#4caf50_0%,_#388e3c_100%)] dark:!bg-[linear-gradient(90deg,_#3ddc84_0%,_#34c98b_100%)]'
					onClick={onClick}
				>
					{t('cta')}
				</Button>
			)}
			<div className='disclaimer-container'>
				{!!maxKwh && maxKwh !== 0 && (
					<span className='disclaimer'>
						{t('maxConsumptionDisclaimer', {
							maxKwh: maxKwh.toLocaleString('en').replace(/,/g, ' '),
						})}
					</span>
				)}
				{isSpot && <span className='disclaimer'>{t('spotDisclaimer')}</span>}
			</div>
		</IonCard>
	)
}

export default ProductShowcaseCard
